import React from "react";
import "./Menu.css";

const Menu = ({ onRouteChange }) => {
  return (
    <div className="wrapper">
        <h1>Snake Game</h1>
      <div>
        <input
          onClick={onRouteChange}
          className="start"
          type="button"
          value="start game"
        />
      </div>
    </div>
  );
};

export default Menu;
